// src/pages/admin/AllFeatures.jsx
import React, { useEffect, useState } from "react";
import { ref, onValue, remove, update } from "firebase/database";
import { dimaniwasRtdb } from "../../firebase/config";
import styles from "./allproduct.module.css";

const AllFeatures = () => {
    const [features, setFeatures] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedFeature, setSelectedFeature] = useState(null);
    const [editFeature, setEditFeature] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        const featuresRef = ref(dimaniwasRtdb, "features");

        const unsubscribe = onValue(featuresRef, (snapshot) => {
            const data = snapshot.val();
            const loadedFeatures = [];
            for (let key in data) {
                loadedFeatures.push({ id: key, ...data[key] });
            }
            setFeatures(loadedFeatures.reverse());
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const handleDelete = (featureId) => {
        if (window.confirm("Are you sure you want to delete this feature?")) {
            remove(ref(dimaniwasRtdb, `features/${featureId}`));
        }
    };

    const handleEditChange = (e) => {
        setEditFeature({ ...editFeature, [e.target.name]: e.target.value });
    };

    const handleEditSave = () => {
        const { id, title, image } = editFeature;
        update(ref(dimaniwasRtdb, `features/${id}`), { title, image });
        document.getElementById("editClose").click();
    };

    return (
        <div className={`d-flex flex-column flex-md-row ${styles.allProduct_container}`}>
            {/* Sidebar toggle for mobile */}
            <button className="btn btn-dark d-md-none m-2" onClick={() => setSidebarOpen(!sidebarOpen)}>
                ☰ Menu
            </button>

            {/* Sidebar */}
            <div className={`bg-dark text-white p-4 ${styles.sidebar} ${sidebarOpen ? "d-block" : "d-none"} d-md-block`}>
                <h4 className="mb-4">Admin</h4>
                <ul className="nav flex-column" style={{ marginLeft: "-15px" }}>
                    <li><a href="/admin/dashboard" className="nav-link text-white">Dashboard</a></li>
                    <li><a href="/admin/add-tent" className="nav-link text-white">Add Tent</a></li>
                    <li><a href="/admin/all-tents" className="nav-link text-white">Manage Tents</a></li>
                    <li><a href="/admin/add-feature" className="nav-link text-white">Add Feature</a></li>
                    <li><a href="/admin/all-features" className="nav-link active text-warning">Manage Features</a></li>
                </ul>
            </div>

            {/* Main content */}
            <div className={`p-4 w-100 ${styles.main}`}>
                <h2 className={styles.allProduct_heading}>All Features</h2>
                {loading ? (
                    <p className={styles.allProduct_loader}>Loading...</p>
                ) : features.length === 0 ? (
                    <p className={styles.allProduct_noData}>No features found.</p>
                ) : (
                    <div className={`table-responsive ${styles.allProduct_tableWrapper}`}>
                        <table className={`table table-bordered table-striped ${styles.allProduct_table}`}>
                            <thead className="table-dark">
                                <tr>
                                    <th>Image</th>
                                    <th>Title</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {features.map((f) => (
                                    <tr key={f.id}>
                                        <td>
                                            <img src={f.image} alt={f.title} className={styles.allProduct_img} />
                                        </td>
                                        <td>{f.title}</td>
                                        <td>
                                            <button className="btn btn-sm btn-primary me-1" data-bs-toggle="modal" data-bs-target="#viewModal" onClick={() => setSelectedFeature(f)}>
                                                View
                                            </button>
                                            <button className="btn btn-sm btn-warning me-1" data-bs-toggle="modal" data-bs-target="#editModal" onClick={() => setEditFeature(f)}>
                                                Edit
                                            </button>
                                            <button className="btn btn-sm btn-danger" onClick={() => handleDelete(f.id)}>Delete</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* View Modal */}
            <div className="modal fade" id="viewModal" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Feature Details</h5>
                            <button type="button" className="btn-close shadow-none" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            {selectedFeature && (
                                <>
                                    <img src={selectedFeature.image} alt={selectedFeature.title} className="img-fluid mb-3" />
                                    <p><strong>Title:</strong> {selectedFeature.title}</p>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Modal */}
            <div className="modal fade" id="editModal" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Feature</h5>
                            <button type="button" className="btn-close shadow-none" data-bs-dismiss="modal" id="editClose" />
                        </div>
                        <div className="modal-body">
                            {editFeature && (
                                <>
                                    <div className="mb-2">
                                        <label>Title</label>
                                        <input type="text" className="form-control shadow-none" name="title" value={editFeature.title} onChange={handleEditChange} />
                                    </div>
                                    <div className="mb-2">
                                        <label>Image URL</label>
                                        <input type="text" className="form-control shadow-none" name="image" value={editFeature.image} onChange={handleEditChange} />
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-success" onClick={handleEditSave}>Save Changes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllFeatures;
